export default "__VITE_ASSET__tk2LDyLs__"